import {ProductInterface} from "../../interfaces/product/ProductInterface";

export default function TechDoc({product}:{product: ProductInterface}) {
    return (<div className="flex-column flex-lg-row gap-4 fade justify-content-between prod-pane tab-pane"
                 id="tech"
                 role="tabpanel" aria-labelledby="tech-tab">
        <div className="d-flex flex-column prod-pane__left">
            <div className="prod-pane__text">
                <p className="fw-bold text-uppercase">техническая документация</p>
                <p className="fw-bold text-uppercase">Фонарь светодиодный аккумуляторный, А90065</p>
                <p>
                    Портативные светодиодные лампы применяются для освещения труднодоступных мест при
                    производстве работ
                    по обслуживанию изделий машиностроения, а также в качестве основного освещения в
                    условиях
                    недостаточной видимости.
                </p>
            </div>
        </div>
        <div className="d-flex flex-column prod-pane__right">
            <div className="d-flex flex-column pane-brand prod-pane__brand">
                <div className="d-flex justify-content-between gap-3 pane-brand__head">
                    <div className="d-flex flex-column pane-brand__head-body">
                        <div className="d-flex align-items-center pane-brand__text-logo">
                            <p className="fw-bold text-uppercase">OMBRA</p>
                            <div className="pane-brand__hint" data-bs-toggle="tooltip"
                                 data-bs-placement="right"
                                 data-bs-title="Подсказка справа">
                                <img src="images/logo-hint.svg" alt=""/>
                            </div>
                        </div>
                        <a href="#">Все товары бренда</a>
                    </div>
                    <div className="pane-brand__logo">
                        <img className="w-100" src="images/desc-logo.svg" alt=""/>
                    </div>
                </div>
                <div className="d-flex flex-column pane-brand__bot">
                    <div className="d-flex align-items-center pane-brand__bot-item">
                        <img src="images/icon-ros.svg" alt=""/>
                        <p>Россия – родина бренда</p>
                    </div>
                    <div className="d-flex align-items-center pane-brand__bot-item">
                        <img src="images/icon-kit.svg" alt=""/>
                        <p>Китай – страна производства</p>
                    </div>
                </div>
            </div>
            <div className="d-flex flex-column prod-pane__right-body">
                <p className="fw-bold text-uppercase">комплектация</p>
                <ul className="d-flex flex-column">
                    <li>
                        <span className="t-orange cicle">●</span><span>Фонарь светодиодный аккумуляторный, карманный</span>
                    </li>
                    <li>
                                        <span
                                            className="t-orange cicle">●</span><span>Кабель зарядки USB - USBtypeC.</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>)
}